
































import { Component, Prop, PropSync } from "vue-property-decorator";
import BaseModal from "./template/BaseModal.vue";

@Component({
  name: "popup-component",
})
export default class PopupComponent extends BaseModal {
  @Prop({ default: "" })
  public title!: string;

  @Prop({ default: "" })
  public content!: string;

  @Prop({ default: "" })
  public onPopupClose!: string;

  @PropSync("buttons", { type: Array })
  public syncedButtons!: [];

  @Prop({ default: false, type: Boolean })
  public buttonsDisable!: boolean;

  /**
   * Event handler for each button that receives an EMIT
   * @param event
   */
  private eventHandler(event: string): void {
    if (event) {
      this.$emit(event);
    }
  }

  /**
   * Event handler for when you hit close
   * @param value
   */
  private onModalToggle(value: boolean) {
    if (!value && this.onPopupClose) {
      this.$emit(this.onPopupClose, value);
    }
  }
}
